import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text, HStack } from '@library';
import styles from '../../ProductTileView/ProductPricing.module.css';
import { ProgressSpinner } from '../../../../core/components/ProgressIndicators';
import usePriceFormatter from '../../../../core/hooks/usePriceFormatter';
import type { ProductCustomerPrice } from '../../../types';
import Price from '../../../../pricing/components/Price';

const ReplacementProductTabletViewMyHEKPrice = ({
    pricingInfo,
    loading = false,
}: {
    pricingInfo?: ProductCustomerPrice;
    loading?: boolean;
}) => {
    const priceFormatter = usePriceFormatter();
    const formattedPrice = priceFormatter(pricingInfo?.finalPrice ?? 0);

    return (
        <div
            className={styles.productMyHEKPrice}
            data-test-class="priceContainer"
            data-test-state="customerPrice"
        >
            <HStack align="baseline" justify="spaceBetween">
                <div className={styles.priceTitle}>
                    <Text tertiary bold>
                        <FormattedMessage id="my dealer price" />
                    </Text>
                </div>
                {loading ? (
                    <div className={styles.spinner}>
                        <ProgressSpinner />
                    </div>
                ) : (
                    <Price customerPrice={pricingInfo}>
                        <HStack>
                            <div className={styles.currency}>
                                <Text tertiary>
                                    <FormattedMessage
                                        id={formattedPrice.currency}
                                    />
                                </Text>
                            </div>
                            <div className={styles.price}>
                                <Text primary bold>
                                    {formattedPrice.price}
                                </Text>
                            </div>
                        </HStack>
                    </Price>
                )}
            </HStack>
            <div className={styles.taxInfo}>
                <Text caption>
                    <FormattedMessage id="plus VAT" />
                </Text>
            </div>
        </div>
    );
};

export default memo(ReplacementProductTabletViewMyHEKPrice);
